import styled from "styled-components";

export const LiteTradeMarketAssetStyled = styled.div`
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 12px;
  background: var(--color-fill-secondary);
  border-radius: 12px;

  &.search {
    background: none;
  }

  &.inactive {
    .col-left {
      opacity: 0.5;
    }

    .col-center {
      color: var(--color-label-secondary);
    }

    .col-right {
      opacity: 0.6;
    }

    .asset-row-info {
      opacity: 0.6;
    }

    .progress {
      &:after {
        background: rgba(129, 146, 228, 0.2);
      }
    }
  }
`;

export const LiteTradeMarketAssetRowStyled = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  max-width: 100%;
  overflow: hidden;

  .col-left {
    font-size: 28px;
    display: flex;
    align-items: center;
  }

  .col-center {
    flex: 1;
    overflow: hidden;
    white-space: nowrap;

    * {
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  .col-right {
    text-align: right;
    flex-shrink: 0;
  }
`;

export const LiteTradeMarketAssetSentimentStyled = styled.div`
  margin-top: 12px;
  font-size: 14px;
  
  .selling {
    color: var(--color-neutral-secondary);
  }
  .buying {
    color: var(--color-neutral);
  }
`;

export const LiteTradeMarketAssetSentimentProgressStyled = styled.div<{ percent: number }>`
  border-radius: 2px;
  height: 4px;
  position: relative;
  margin-bottom: 4px;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    border-radius: 2px 0 0 2px;
    width: calc(${({ percent }) => 100 - percent}% - 1px);
    background-color: var(--color-neutral-secondary);
  }

  &:before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 4px;
    border-radius: 0 2px 2px 0;
    width: calc(${({ percent }) => percent}% - 1px);
    background: var(--color-neutral);
  }
`;